import { createSlice } from "@reduxjs/toolkit";

const businessSlice = createSlice({
  name: "selectedBusiness",
  initialState: { user: null },
  reducers: {
    setBusinessUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setBusinessUser } = businessSlice.actions;
export default businessSlice.reducer;
